import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import Seo from "./Seo";
import StickyCTA from "./StickyCTA";

export default function SiteShell({ title, description, children, testId = "site-page" }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid={testId}>
      <Seo title={title} description={description} />
      <Nav />
      <main>{children}</main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
